import Vue from 'vue'
import Vuetify from 'vuetify' // Import Vuetify to your project

Vue.use(Vuetify) // Add Vuetify as a plugin



// WEBPACK FOOTER //
// ./resources/js/plugins/vuetify.js